'use strict';
var $ = window.$ = window.jQuery = require('jquery');
window.jQuery = $;
require('select2');

import 'NodeModules/web-animations-js/web-animations.min.js';

import angular from 'angular';
import 'angular-animate';
import 'angular-sanitize';
import select2Patch from './select2.js';


var mockData = require('./mock-api-response.json');

var _ = require('lodash'),
    defaults = {
        width: "100%", // fix bug with dropdown widths
        minimumResultsForSearch: -1, // hide search input
        placeholder: 'All Categories',
    },
    clearable = {
        allowClear: true
    },
    searchable = {
        minimumResultsForSearch: 1
    },
    nonClosable = {
        closeOnSelect: false
    };

// Create Angular app.
var app = angular.module('app', ['ngSanitize', 'ngAnimate', 'ui.bootstrap']);

app.factory('Context', function() {
    return {
        layout: '',
        template: '',
        settings: {
            center: {
                id: 1
            }
        }
    };
});

app.factory('Map', ['$http', function($http) {
    return {
        get: function() {
            var apiUrl = '/umbraco/rhythm/mapapi/mapdata';
            return $http.get(apiUrl);
        }
    };
}]);

app.directive('select2', select2Patch);

//services
require('./scroll.js');
require('./modal.js');

require('./modal-map.js');
require('./center-map.js');
require('./vendor/ui-bootstrap-custom-tpls-1.2.5.min');

$(function() {
    $('.select2').each(function(el) {
        var options = _.clone(defaults);
        if ($(this).hasClass('select2-clearable')) options = _.merge(options, clearable);
        if ($(this).hasClass('select2-searchable')) options = _.merge(options, searchable);
        if ($(this).hasClass('select2-non-closable')) options = _.merge(options, nonClosable);
        $(this).select2(options);
    });
});